module.exports = __webpack_public_path__ + "img/mro_y_consumibles_industriales.14aa0b6b.jpg";